import { c as _c } from "react/compiler-runtime";
import type { PortableTextBlock } from "sanity";
import classNames from "classnames";
import React from "react";
import RichText from "src/components/richtext/Richtext";
import styles from "./MainText.module.css";
import { stripEmptyParagraphs } from "src/lib/server/stripEmptyParagraphs";
import { splitBlocksForAds } from "src/lib/richtext/splitBlocksForAds";
import { replaceOldStreamingProviderLinks } from "src/lib/richtext/replaceOldStreamingProviderLinks";

//#region [Props]
type MainTextProps = {
  className?: string;
  mainText?: PortableTextBlock[] | null;
  includeAds?: boolean;
  children?: React.ReactNode;
};
//#endregion

//#region [Component]
export default function MainText(t0) {
  const $ = _c(13);
  const {
    className,
    mainText,
    includeAds,
    children
  } = t0;
  if ((mainText?.length ?? 0) === 0) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== includeAds || $[3] !== mainText) {
    let _transformedMainText = stripEmptyParagraphs(mainText);
    _transformedMainText = replaceOldStreamingProviderLinks(_transformedMainText);
    let _mainText = [_transformedMainText];
    let childrenArray;
    if (includeAds && children && React.Children.count(children) > 0) {
      _mainText = splitBlocksForAds(_transformedMainText);
      if (_mainText.length > 1) {
        childrenArray = React.Children.toArray(children);
      }
    }
    if ($[6] !== className) {
      t1 = classNames(styles.SBodyTextContainer, className);
      $[6] = className;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t3;
    if ($[8] !== childrenArray) {
      t3 = (chunk, idx) => <React.Fragment key={idx}>{idx > 0 && (childrenArray?.[idx - 1] ?? null)}<RichText className={styles.SBodyText} value={chunk} /></React.Fragment>;
      $[8] = childrenArray;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = _mainText.map(t3);
    $[0] = children;
    $[1] = className;
    $[2] = includeAds;
    $[3] = mainText;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
//#endregion